export const RAG_SUPABASE_MODULE_1 = {
  id: 'rag-supabase-intro',
  title: 'RAG on Supabase: From Zero to Production',
  description: 'Build a Retrieval-Augmented Generation pipeline using Supabase, embeddings, and a lightweight API.',
  content: `# RAG on Supabase\n\n## Architecture\n- Chunk documents, embed, store vectors in Supabase\n- Retrieve top-k by similarity, construct prompt, call LLM\n\n## Steps\n1. Create table: documents (id uuid, content text) and vectors (embedding vector)\n2. Generate embeddings (OpenAI/Azure) and upsert into Supabase\n3. Query with cosine similarity using RPC or SQL\n4. Compose final prompt and call LLM\n\n## Example SQL\nSELECT id, content\nFROM documents\nORDER BY embedding <=> query_embedding\nLIMIT 5;\n\n## Best Practices\n- Normalize text, consistent chunking\n- Cache frequent queries\n- Add feedback loop to improve results`,
  duration: '50 minutes',
  difficulty: 'intermediate' as const,
  order: 1,
  estimatedTime: '50 minutes',
  objectives: [
    'Understand RAG architecture on Supabase',
    'Embed and store vectors',
    'Retrieve and construct prompts',
  ],
  practice: {
    task: 'Ingest 10 docs, build a vector search endpoint, and answer a question with cited sources.',
    estimatedTime: 90,
  },
  quiz: {
    questions: [
      {
        id: 'rag-q1',
        question: 'What is the purpose of embeddings in a RAG system?',
        options: ['Tokenization', 'Semantic search', 'Caching', 'Rate limiting'],
        correctAnswer: 1,
      },
    ],
  },
};
